module.exports = __webpack_public_path__ + "static/media/header-photo.9a21d75d.jpg";